import { useParams, Navigate } from 'react-router-dom';
import FeaturePageTemplate from './FeaturePageTemplate';
import { FeaturesConfig } from './FeaturesConfig';

function StFeaturePage() {
    const { featureSlug } = useParams();
    const feature = FeaturesConfig[featureSlug];

    if (!feature) {
        return <Navigate to="/not-found" replace />;
    }

    return <FeaturePageTemplate feature={feature} />;
}

export default StFeaturePage;
